export default {
	setCashBalance: (state, { cash_balance, currency }) => {
		state.cashBalance[currency] = cash_balance
	},
	setAccountShareHoldings: (state, accountShareHoldings) => {
		state.accountShareHoldings = accountShareHoldings
	},
}
